import React, { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { ArrowLeft, Activity, Filter, Search, Calendar, User, FileText, Settings, Shield } from 'lucide-react';
import { Button } from '../../components/ui/Button';
import { Card, CardContent } from '../../components/ui/Card';
import { Badge } from '../../components/ui/Badge';
import { Input } from '../../components/ui/Input';
export function AdminActivities() {
  const navigate = useNavigate();
  const [searchQuery, setSearchQuery] = useState('');
  const activities = [{
    id: 1,
    user: 'Budi Santoso',
    action: 'membuat acara baru',
    target: 'Workshop React Advanced',
    type: 'event',
    timestamp: '2025-01-15 14:30:00',
    icon: Calendar,
    color: 'text-atios-primary'
  }, {
    id: 2,
    user: 'Siti Nurhaliza',
    action: 'menyetujui keanggotaan',
    target: 'John Doe',
    type: 'approval',
    timestamp: '2025-01-15 14:15:00',
    icon: User,
    color: 'text-success'
  }, {
    id: 3,
    user: 'Ahmad Wijaya',
    action: 'membuat laporan',
    target: 'Laporan Keuangan Q4 2024',
    type: 'report',
    timestamp: '2025-01-15 13:00:00',
    icon: FileText,
    color: 'text-warning'
  }, {
    id: 4,
    user: 'Admin System',
    action: 'mengubah pengaturan',
    target: 'Konfigurasi Email',
    type: 'settings',
    timestamp: '2025-01-15 12:30:00',
    icon: Settings,
    color: 'text-neutral-600'
  }, {
    id: 5,
    user: 'Dewi Lestari',
    action: 'menolak permohonan',
    target: 'Ahmad Fauzi',
    type: 'rejection',
    timestamp: '2025-01-15 11:45:00',
    icon: Shield,
    color: 'text-error'
  }];
  const filteredActivities = activities.filter(activity => activity.user.toLowerCase().includes(searchQuery.toLowerCase()) || activity.action.toLowerCase().includes(searchQuery.toLowerCase()) || activity.target.toLowerCase().includes(searchQuery.toLowerCase()));
  const getActivityBadge = (type: string) => {
    switch (type) {
      case 'event':
        return <Badge variant="primary" data-id="element-458">Acara</Badge>;
      case 'approval':
        return <Badge variant="success" data-id="element-459">Persetujuan</Badge>;
      case 'report':
        return <Badge variant="warning" data-id="element-460">Laporan</Badge>;
      case 'settings':
        return <Badge variant="default" data-id="element-461">Pengaturan</Badge>;
      case 'rejection':
        return <Badge variant="error" data-id="element-462">Penolakan</Badge>;
      default:
        return <Badge data-id="element-463">Lainnya</Badge>;
    }
  };
  return <div className="min-h-screen bg-white" data-id="element-464">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-8" data-id="element-465">
        {/* Header */}
        <div className="mb-8" data-id="element-466">
          <Button variant="ghost" onClick={() => navigate('/admin/dashboard')} className="mb-4" data-id="element-467">
            <ArrowLeft className="w-4 h-4 mr-2" data-id="element-468" />
            Kembali ke Dasbor
          </Button>
          <div className="flex justify-between items-start" data-id="element-469">
            <div data-id="element-470">
              <h1 className="text-3xl font-semibold text-neutral-900 mb-2" data-id="element-471">
                Log Aktivitas
              </h1>
              <p className="text-neutral-600" data-id="element-472">
                Pantau semua aktivitas pengguna di sistem
              </p>
            </div>
            <Button variant="secondary" data-id="element-473">
              <Filter className="w-4 h-4 mr-2" data-id="element-474" />
              Filter
            </Button>
          </div>
        </div>

        {/* Search */}
        <div className="mb-6" data-id="element-475">
          <div className="relative" data-id="element-476">
            <Search className="absolute left-3 top-1/2 -translate-y-1/2 h-4 w-4 text-neutral-400" data-id="element-477" />
            <Input placeholder="Cari aktivitas..." value={searchQuery} onChange={e => setSearchQuery(e.target.value)} className="pl-10" data-id="element-478" />
          </div>
        </div>

        {/* Activities List */}
        <Card data-id="element-479">
          <CardContent className="p-6" data-id="element-480">
            <div className="space-y-4" data-id="element-481">
              {filteredActivities.map(activity => <div key={activity.id} className="flex items-start gap-4 p-4 rounded-lg border border-neutral-200 hover:border-atios-primary transition-all" data-id="element-482">
                  <div className={`p-3 rounded-lg bg-neutral-100 ${activity.color}`} data-id="element-483">
                    <activity.icon className="w-5 h-5" data-id="element-484" />
                  </div>
                  <div className="flex-1" data-id="element-485">
                    <div className="flex items-start justify-between mb-2" data-id="element-486">
                      <div data-id="element-487">
                        <p className="text-sm text-neutral-900" data-id="element-488">
                          <span className="font-semibold" data-id="element-489">{activity.user}</span>{' '}
                          {activity.action}{' '}
                          <span className="font-semibold" data-id="element-490">
                            {activity.target}
                          </span>
                        </p>
                        <p className="text-xs text-neutral-500 mt-1" data-id="element-491">
                          {new Date(activity.timestamp).toLocaleString('id-ID', {
                        dateStyle: 'long',
                        timeStyle: 'short'
                      })}
                        </p>
                      </div>
                      {getActivityBadge(activity.type)}
                    </div>
                  </div>
                </div>)}
            </div>
          </CardContent>
        </Card>
      </div>
    </div>;
}